import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Output
} from '@angular/core';

@Component({
  selector: 'axis-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  host: {
    '[attr.data-col]': 'col',
    '[class._align-right]': 'isIconAlignRight',
    '[class.axis-dropdown]': 'true',
    '[class.axis-dropdown-ul]': 'true',
    '[class.has-axis-custom]': 'hasAxisCustom',
    '[class.has-axis-multicolumn]': 'col',
    '[class.has-icon]': 'isIcon',
    '[class.open]': 'isOpen',
    'role': 'region'
  }
})
export class DropdownMenuComponent implements AfterViewInit {

  hasAxisCustom = false;
  wrap: boolean;

  public col: any;
  public isIcon = false;
  public isIconAlignRight = false;
  public isMultiSelect = false;
  public isOpen: any;

  @Output() resizeEvent = new EventEmitter();

  ngAfterViewInit() {
    setTimeout(() => {
      this.resizeEvent.emit();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    if (this.wrap) {
      this.resizeEvent.emit(event);
    }
  }
}
